<ng-container>
	<app-ea-spinner *ngIf="!exploitation"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="exploitation">
		<div class="col-12">
			<p-toast></p-toast>
			<div class="widget-header flex flex-wrap align-items-center justify-content-between pt-3 pb-5">
				<div class="header-left-section flex align-items-center justify-content-start mb-3 md:mb-0">
					<div class="ml-3 mb-2 md:mb-0">
						<span class="block text-4xl font-bold"
							>{{ exploitation.name }}
							<p-tag
								*ngIf="exploitation.type === 'FAKE'"
								styleClass="mr-2"
								severity="danger"
								value="{{ exploitation.type | enumToKey | translate }}"
								[rounded]="true"></p-tag>
						</span>
						<span class="block text-4xl font-bold"
							>{{ "cheptel.nomsingulier" | translate }} {{ exploitation.numeroCheptel }}</span
						>
						<span class="header block white-space-nowrap overflow-hidden"
							>{{ "cree.le" | translate }} {{ exploitation.created | date : "longDate" }}</span
						>
						<span class="header block white-space-nowrap overflow-hidden"
							>{{ "derniere.maj" | translate }} {{ exploitation.updated | date : "longDate" }}</span
						>
					</div>
				</div>

				<div *ngIf="exploitation.type !== 'FAKE'">
					<div class="header-right-section flex justify-content-end">
						<button
							*ngIf="exploitation.enabled === 'ENABLED'"
							pButton
							pRipple
							label="{{ 'cheptel.desactive' | translate }}"
							icon="pi pi-power-off"
							class="p-button-danger mb-2 ml-2"
							(click)="changeCheptelState()"></button>
						<button
							*ngIf="exploitation.enabled === 'DISABLED'"
							pButton
							pRipple
							label="{{ 'cheptel.active' | translate }}"
							icon="pi pi-power-off"
							class="p-button-success mb-2 ml-2"
							(click)="changeCheptelState()"></button>
					</div>
					<div
						class="header-right-section flex justify-content-end"
						*ngIf="exploitation.enabled === 'ENABLED'">
						<!-- La propriété synchronizationStatus n'existe plus, seul le bouton de désactivation est disponible -->
						<button
							pButton
							pRipple
							label="{{ 'synchro.desactive' | translate }}"
							icon="pi pi-power-off"
							class="p-button-danger mb-2 ml-2"
							(click)="changeSynchroState()"></button>
					</div>
				</div>
			</div>
			<div class="flex grid p-fluid">
				<div class="col-12 md:col-6 xl:col-6">
					<div class="card">
						<h5 style="display: inline-block">{{ "permission.features" | translate }}</h5>
						<button
							pButton
							pRipple
							icon="pi pi-pencil"
							class="p-button-rounded p-button-info mr-2"
							style="float: right"
							(click)="selectedProperty = 'features'; editPermissions()"></button>

						<ul class="list-none p-0">
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureDisplayAlertes')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureDisplayAlertes" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureDisplayAlertes === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureDisplayAlertes === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureDisplayAlertes')" />

							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureDisplayEquarrissage')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureDisplayEquarrissage" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureDisplayEquarrissage === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureDisplayEquarrissage === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureDisplayEquarrissage')" />

							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureCommandeBoucles')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureCommandeBoucles" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureCommandeBoucles === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureCommandeBoucles === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureCommandeBoucles')" />

							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="exploitation.hasOwnProperty('featureDisplayTaches')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<span class="font-bold block" style="padding-right: 10px"-->
							<!--									>{{ "permission.featureDisplayTaches" | translate }}-->
							<!--									</span>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureDisplayTaches === 'ENABLED'"-->
							<!--										class="customer-badge status-active"-->
							<!--									>{{ "etat.active" | translate }}</span-->
							<!--									>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureDisplayTaches === 'DISABLED'"-->
							<!--										class="customer-badge status-desactive"-->
							<!--									>{{ "etat.desactive" | translate }}</span-->
							<!--									>-->
							<!--								</div>-->
							<!--							</li>-->
							<!--							<hr *ngIf="exploitation.hasOwnProperty('featureDisplayTaches')" />-->
							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="exploitation.hasOwnProperty('featureSaisieIpe')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<span class="font-bold block" style="padding-right: 10px"-->
							<!--									>{{ "permission.featureSaisieIpe" | translate }}-->
							<!--									</span>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureSaisieIpe === 'ENABLED'"-->
							<!--										class="customer-badge status-active"-->
							<!--									>{{ "etat.active" | translate }}</span-->
							<!--									>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureSaisieIpe === 'DISABLED'"-->
							<!--										class="customer-badge status-desactive"-->
							<!--									>{{ "etat.desactive" | translate }}</span-->
							<!--									>-->
							<!--								</div>-->
							<!--							</li>-->
							<!--							<hr *ngIf="exploitation.hasOwnProperty('featureSaisieIpe')" />-->
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('mouvement')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.mouvement" | translate }}
									</span>
									<span
										*ngIf="exploitation.mouvement === FlagMouvement.MOUVEMENT_ENABLED"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.mouvement === FlagMouvement.MOUVEMENT_DISABLED"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('mouvement')" />
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureSaisiePesee')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureSaisiePesee" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureSaisiePesee === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureSaisiePesee === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureSaisiePesee')" />
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureSaisieReproduction')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureSaisieReproduction" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureSaisieReproduction === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureSaisieReproduction === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureSaisieReproduction')" />
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.hasOwnProperty('featureSaisieSanitaire')">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureSaisieSanitaire" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureSaisieSanitaire === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureSaisieSanitaire === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr *ngIf="exploitation.hasOwnProperty('featureSaisieSanitaire')" />
							<li class="flex align-items-center justify-content-between pt-2 pb-3">
								<div class="flex align-items-center justify-content-start">
									<span class="font-bold block" style="padding-right: 10px"
										>{{ "permission.featureUpdateLots" | translate }}
									</span>
									<span
										*ngIf="exploitation.featureUpdateLots === 'ENABLED'"
										class="customer-badge status-active"
										>{{ "etat.active" | translate }}</span
									>
									<span
										*ngIf="exploitation.featureUpdateLots === 'DISABLED'"
										class="customer-badge status-desactive"
										>{{ "etat.desactive" | translate }}</span
									>
								</div>
							</li>
							<hr />
							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="exploitation.hasOwnProperty('featureCommandeIA')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<span class="font-bold block" style="padding-right: 10px"-->
							<!--									>{{ "permission.featureCommandeIA" | translate }}-->
							<!--									</span>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureCommandeIA === 'ENABLED'"-->
							<!--										class="customer-badge status-active"-->
							<!--									>{{ "etat.active" | translate }}</span-->
							<!--									>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureCommandeIA === 'DISABLED'"-->
							<!--										class="customer-badge status-desactive"-->
							<!--									>{{ "etat.desactive" | translate }}</span-->
							<!--									>-->
							<!--								</div>-->
							<!--							</li>-->
							<!--							<hr *ngIf="exploitation.hasOwnProperty('featureCommandeIA')" />-->
							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="exploitation.hasOwnProperty('featureChatBot')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<span class="font-bold block" style="padding-right: 10px"-->
							<!--									>{{ "permission.featureChatBot" | translate }}-->
							<!--									</span>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureChatBot === 'ENABLED'"-->
							<!--										class="customer-badge status-active"-->
							<!--									>{{ "etat.active" | translate }}</span-->
							<!--									>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.featureChatBot === 'DISABLED'"-->
							<!--										class="customer-badge status-desactive"-->
							<!--									>{{ "etat.desactive" | translate }}</span-->
							<!--									>-->
							<!--								</div>-->
							<!--							</li>-->
							<!--							<hr *ngIf="exploitation.hasOwnProperty('featureChatBot')" />-->
							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="exploitation.hasOwnProperty('vae')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<span class="font-bold block" style="padding-right: 10px"-->
							<!--									>{{ "permission.vae" | translate }}-->
							<!--									</span>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.vae === 'VAE_ENABLED'"-->
							<!--										class="customer-badge status-active"-->
							<!--									>{{ "etat.active" | translate }}</span-->
							<!--									>-->
							<!--									<span-->
							<!--										*ngIf="exploitation.vae === 'VAE_DISABLED'"-->
							<!--										class="customer-badge status-desactive"-->
							<!--									>{{ "etat.desactive" | translate }}</span-->
							<!--									>-->
							<!--								</div>-->
							<!--							</li>-->
						</ul>
					</div>
				</div>

				<div class="col-12 md:col-6 xl:col-6">
					<div class="card widget-list-type2">
						<h5>{{ "proprietes.titre" | translate }}</h5>
						<ul class="list-none p-0">
							<li class="flex align-items-center justify-content-between pt-2 pb-3">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2">
										<span class="font-bold block"
											>{{ "proprietes.offreAbonnement" | translate }} :
											{{ exploitation.offreAbonnement | enumToKey | translate }}</span
										>
									</div>
								</div>
								<button
									pButton
									pRipple
									icon="pi pi-pencil"
									class="p-button-rounded p-button-info mr-2"
									(click)="selectedProperty = 'offreAbonnement'; editPermissions()"></button>
							</li>
							<hr />
							<li class="flex align-items-center justify-content-between pt-2 pb-3">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2">
										<span class="font-bold block">{{ "proprietes.ftp" | translate }}</span>
									</div>
								</div>
								<button
									pButton
									pRipple
									icon="pi pi-pencil"
									class="p-button-rounded p-button-info mr-2"
									(click)="openEditFtpDialog()"></button>
							</li>
							<hr *ngIf="exploitation.type === 'FAKE'" />
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="exploitation.type === 'FAKE'">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2">
										<span class="font-bold block"
											>{{ "proprietes.type" | translate }} :
											{{ exploitation.type | enumToKey | translate }}</span
										>
									</div>
								</div>

								<button
									pButton
									pRipple
									disabled
									icon="pi pi-lock"
									class="p-button-rounded p-button-secondary mr-2"
									(click)="selectedProperty = 'type'; editPermissions()"></button>
							</li>
							<!--							<hr *ngIf="hasProperty('filiere')" />-->
							<!--							<li-->
							<!--								class="flex align-items-center justify-content-between pt-2 pb-3"-->
							<!--								*ngIf="hasProperty('filiere')">-->
							<!--								<div class="flex align-items-center justify-content-start">-->
							<!--									<div class="ml-2">-->
							<!--										<span class="font-bold block"-->
							<!--										>{{ "proprietes.filiere" | translate }} :-->
							<!--											{{ exploitation.filiere | enumToKey | translate }}</span-->
							<!--										>-->
							<!--									</div>-->
							<!--								</div>-->

							<!--								<button-->
							<!--									pButton-->
							<!--									pRipple-->
							<!--									disabled-->
							<!--									icon="pi pi-lock"-->
							<!--									class="p-button-rounded p-button-secondary mr-2"-->
							<!--									(click)="editPermissions()"></button>-->
							<!--							</li>-->
							<hr *ngIf="hasProperty('identifiantPrimaire')" />
							<li
								class="flex align-items-center justify-content-between pt-2 pb-3"
								*ngIf="hasProperty('identifiantPrimaire')">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2">
										<span class="font-bold block"
											>{{ "proprietes.identifiantPrimaire" | translate }}
											:
											{{ exploitation.identifiantPrimaire | enumToKey | translate }}</span
										>
									</div>
								</div>

								<button
									pButton
									pRipple
									disabled
									icon="pi pi-lock"
									class="p-button-rounded p-button-secondary mr-2"
									(click)="editPermissions()"></button>
							</li>
						</ul>
					</div>
				</div>
				<div class="col-12 md:col-12 xl:col-6">
					<div class="card widget-list-type2">
						<p-table
							#dt
							[value]="listeUsersDuCheptel"
							[(selection)]="selectedUserDuCheptel"
							dataKey="id"
							styleClass="p-datatable-userducheptel"
							[rowHover]="true"
							[rows]="listeUsersDuCheptel.length"
							[paginator]="false">
							<ng-template pTemplate="caption" style="display: flex; align-items: center">
								<h5>{{ "user.accessliste" | translate }}</h5>
								<button
									pButton
									pRipple
									label="{{ 'access.add' | translate }}"
									icon="pi pi-plus"
									class="p-button-success mr-2 mb-2"
									(click)="openNewUserAccess()"></button>
							</ng-template>
							<ng-template pTemplate="header">
								<tr>
									<th>
										<div class="flex justify-content-between align-items-center">
											{{ "global.email" | translate }}
										</div>
									</th>
									<th>
										<div class="flex justify-content-between align-items-center">
											{{ "global.niveauaccess" | translate }}
										</div>
									</th>
									<th>{{ "access.editersupprimer2" | translate }}</th>
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-listeUsersDuCheptel let-rowIndex="rowIndex">
								<tr class="p-selectable-row">
									<td>
										<span class="p-column-title">{{ "permission.singulier" | translate }}</span
										>{{ listeUsersDuCheptel.email }}
									</td>
									<td>
										<span class="p-column-title">{{ "global.niveauaccess" | translate }}</span>
										{{ listeUsersNiveauAccesDuCheptel[rowIndex] | enumToKey | translate }}
									</td>
									<td class="flex align-items-center justify-content-between pt-3 pb-2 px-4">
										<button
											pButton
											pRipple
											icon="pi pi-pencil"
											class="p-button-rounded p-button-info mr-2"
											(click)="
												editUserAccessToExploitation(
													listeUsersDuCheptel,
													listeUserExploitationIds[rowIndex],
													listeUsersNiveauAccesDuCheptel[rowIndex]
												)
											"></button>
										<button
											pButton
											pRipple
											icon="pi pi-trash"
											class="p-button-rounded p-button-danger"
											(mousedown)="
												deleteUserAccess(
													listeUsersDuCheptel,
													listeUserExploitationIds[rowIndex]
												)
											"></button>
										<div></div>
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr *ngIf="isUserListLoading">
									<td colspan="8">
										{{ "recuperation.en.cours" | translate }}
										<app-ea-spinner style="float: right"></app-ea-spinner>
									</td>
								</tr>
								<tr *ngIf="!isUserListLoading">
									<td colspan="8">{{ "utilisateur.pasdutilisateur" | translate }}</td>
								</tr>
							</ng-template>
						</p-table>
					</div>
				</div>
				<div class="col-12 md:col-6 xl:col-6 disabled-section">
					<div class="card widget-list-type2">
						<h5>{{ "exploitation.forcerSynchro" | translate }}</h5>
						<ul class="list-none p-0">
							<li class="flex align-items-center justify-content-between pt-2 pb-3">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2" style="width: 200px; /* or any other desired width */">
										<span class="font-bold block" style="overflow: hidden; text-overflow: ellipsis">
											{{ "exploitation.synchroCheptel" | translate }}
										</span>
										<small style="overflow: hidden; text-overflow: ellipsis">
											{{ "exploitation.description.cheptel" | translate }}
										</small>
									</div>
								</div>
								<button
									pButton
									pRipple
									*ngIf="!syncExploitationState"
									icon="pi pi-sync"
									class="p-button-rounded p-button-info mr-2"
									(click)="syncExploitation()"></button>
								<div *ngIf="syncExploitationState" style="max-width: 200px; color: red">
									{{ "waiting.sentence" | translate }}
								</div>
								<app-ea-spinner *ngIf="syncExploitationState" class="mr-2"></app-ea-spinner>
							</li>
							<hr />
							<li class="flex align-items-center justify-content-between pt-2 pb-3">
								<div class="flex align-items-center justify-content-start">
									<div class="ml-2" style="width: 200px; /* or any other desired width */">
										<span class="font-bold block" style="overflow: hidden; text-overflow: ellipsis">
											{{ "exploitation.synchroAnimaux" | translate }}
										</span>
										<small style="overflow: hidden; text-overflow: ellipsis">
											{{ "exploitation.description.animaux" | translate }}
										</small>
									</div>
								</div>
								<button
									pButton
									pRipple
									icon="pi pi-sync"
									class="p-button-rounded p-button-info mr-2"
									*ngIf="!syncAnimauxState"
									(click)="syncAnimaux()"></button>
								<div *ngIf="syncAnimauxState" style="max-width: 200px; color: red">
									{{ "waiting.sentence" | translate }}
								</div>
								<app-ea-spinner *ngIf="syncAnimauxState"></app-ea-spinner>
							</li>
						</ul>
					</div>
				</div>

				<div class="col-12 md:col-6 xl:col-6 disabled-section">
					<div class="card">
						<h5 style="display: inline-block">{{ "exploitation.deleteAnimalCard" | translate }}</h5>
						<div class="formgrid grid flex align-items-center">
							<div class="col-3">
								<label for="animal-delete-code-pays">{{
									"exploitation.animalNumeroNational" | translate
								}}</label>
							</div>
							<div class="col-2">
								<input
									type="text"
									pInputText
									id="animal-delete-code-pays"
									[(ngModel)]="animalToDeleteCodePays"
									required
									maxlength="2"
									onkeypress="if(event.which < 65 || event.which > 90) return false;" />
								<small class="p-invalid red-text" *ngIf="animalToDeleteCodePaysError">{{
									"exploitation.animalCodePaysInvalid" | translate
								}}</small>
							</div>
							<div class="col-3">
								<input
									type="text"
									pInputText
									id="animal-delete-numero-national"
									maxlength="12"
									[(ngModel)]="animalToDeleteNumeroNational"
									required
									onkeypress="if(!((event.which >= 65 && event.which <= 90) || (event.which >= 48 && event.which <= 57))) return false;" />
								<small class="p-invalid red-text" *ngIf="animalToDeleteNumeroNationalError">{{
									"exploitation.animalNumeroNationalInvalid" | translate
								}}</small>
							</div>

							<div class="col-1">
								<button
									pButton
									pRipple
									icon="pi pi-trash"
									class="p-button-rounded p-button-danger"
									(mousedown)="deleteAnimal()"></button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<p-dialog
				[(visible)]="permissionEditionDialog"
				[style]="{ width: '450px' }"
				header="{{ 'global.edition' | translate }}"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<div class="field">
						<div *ngIf="selectedProperty === 'offreAbonnement'">
							<td>{{ "permission.offreAbonnement" | translate }}</td>
							<br />
							<div class="formgrid grid">
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category1"
										name="category"
										value="ESSENTIEL"
										[(ngModel)]="proprietesExploitation.offreAbonnement"></p-radioButton>
									<label for="category1">{{ "offreabonnement.essentiel" | translate }}</label>
								</div>
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category2"
										name="category"
										value="PERFORMANCE"
										[(ngModel)]="proprietesExploitation.offreAbonnement"></p-radioButton>
									<label for="category2">{{ "offreabonnement.performance" | translate }}</label>
								</div>
							</div>
						</div>
						<div *ngIf="selectedProperty === 'type'">
							<td>{{ "permission.type" | translate }}</td>
							<br />
							<div class="formgrid grid">
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category1"
										name="category"
										value="LIVE"
										[(ngModel)]="proprietesExploitation.type"></p-radioButton>
									<label for="category1">{{ "exploitationtype.live" | translate }}</label>
								</div>
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category2"
										name="category"
										value="FAKE"
										[(ngModel)]="proprietesExploitation.type"></p-radioButton>
									<label for="category2">{{ "exploitationtype.fake" | translate }}</label>
								</div>
							</div>
						</div>
						<div *ngIf="selectedProperty === 'features'">
							<td>{{ "permission.features" | translate }}</td>
							<br />
							<ul class="list-none p-0">
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureDisplayAlertes')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureDisplayAlertes" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureDisplayAlertes === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureDisplayAlertes = $event
												? FeatureDisplayAlertes.ENABLED
												: FeatureDisplayAlertes.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureDisplayAlertes')" />
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureDisplayEquarrissage')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureDisplayEquarrissage" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureDisplayEquarrissage === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureDisplayEquarrissage = $event
												? FeatureDisplayEquarrissage.ENABLED
												: FeatureDisplayEquarrissage.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureDisplayEquarrissage')" />

								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureCommandeBoucles')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureCommandeBoucles" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureCommandeBoucles === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureCommandeBoucles = $event
												? FeatureCommandeBoucles.ENABLED
												: FeatureCommandeBoucles.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureCommandeBoucles')" />

								<!--								<li-->
								<!--									class="flex align-items-center justify-content-between pt-2 pb-3"-->
								<!--									*ngIf="exploitation.hasOwnProperty('featureDisplayTaches')">-->
								<!--									<div class="flex align-items-center justify-content-start">-->
								<!--										<div class="ml-2">-->
								<!--											<span class="font-bold block">{{-->
								<!--												"permission.featureDisplayTaches" | translate-->
								<!--											}}</span>-->
								<!--										</div>-->
								<!--									</div>-->

								<!--									<p-inputSwitch-->
								<!--										[ngModel]="proprietesExploitation.featureDisplayTaches === 'ENABLED'"-->
								<!--										(ngModelChange)="-->
								<!--											proprietesExploitation.featureDisplayTaches = $event-->
								<!--												? 'ENABLED'-->
								<!--												: 'DISABLED'-->
								<!--										"></p-inputSwitch>-->
								<!--								</li>-->
								<!--								<hr *ngIf="exploitation.hasOwnProperty('featureDisplayTaches')" />-->
								<!--								<li-->
								<!--									class="flex align-items-center justify-content-between pt-2 pb-3"-->
								<!--									*ngIf="exploitation.hasOwnProperty('featureSaisieIpe')">-->
								<!--									<div class="flex align-items-center justify-content-start">-->
								<!--										<div class="ml-2">-->
								<!--											<span class="font-bold block">{{-->
								<!--												"permission.featureSaisieIpe" | translate-->
								<!--											}}</span>-->
								<!--										</div>-->
								<!--									</div>-->

								<!--									<p-inputSwitch-->
								<!--										[ngModel]="proprietesExploitation.featureSaisieIpe === 'ENABLED'"-->
								<!--										(ngModelChange)="-->
								<!--											proprietesExploitation.featureSaisieIpe = $event ? 'ENABLED' : 'DISABLED'-->
								<!--										"></p-inputSwitch>-->
								<!--								</li>-->
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('mouvement')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.mouvement" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.mouvement === FlagMouvement.MOUVEMENT_ENABLED"
										(ngModelChange)="
											proprietesExploitation.mouvement = $event
												? FlagMouvement.MOUVEMENT_ENABLED
												: FlagMouvement.MOUVEMENT_DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('mouvement')" />
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureSaisiePesee')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureSaisiePesee" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureSaisiePesee === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureSaisiePesee = $event
												? FeatureSaisiePesee.ENABLED
												: FeatureSaisiePesee.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureSaisiePesee')" />
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureSaisieReproduction')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureSaisieReproduction" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureSaisieReproduction === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureSaisieReproduction = $event
												? FeatureSaisieReproduction.ENABLED
												: FeatureSaisieReproduction.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureSaisieReproduction')" />
								<li
									class="flex align-items-center justify-content-between pt-2 pb-3"
									*ngIf="exploitation.hasOwnProperty('featureSaisieSanitaire')">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureSaisieSanitaire" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureSaisieSanitaire === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureSaisieSanitaire = $event
												? FeatureSaisieSanitaire.ENABLED
												: FeatureSaisieSanitaire.DISABLED
										"></p-inputSwitch>
								</li>
								<hr *ngIf="exploitation.hasOwnProperty('featureSaisieSanitaire')" />
								<li class="flex align-items-center justify-content-between pt-2 pb-3">
									<div class="flex align-items-center justify-content-start">
										<div class="ml-2">
											<span class="font-bold block">{{
												"permission.featureUpdateLots" | translate
											}}</span>
										</div>
									</div>

									<p-inputSwitch
										[ngModel]="proprietesExploitation.featureUpdateLots === 'ENABLED'"
										(ngModelChange)="
											proprietesExploitation.featureUpdateLots = $event
												? FeatureUpdateLots.ENABLED
												: FeatureUpdateLots.DISABLED
										"></p-inputSwitch>
								</li>
								<hr />
								<!--								<li-->
								<!--									class="flex align-items-center justify-content-between pt-2 pb-3"-->
								<!--									*ngIf="exploitation.hasOwnProperty('featureCommandeIA')">-->
								<!--									<div class="flex align-items-center justify-content-start">-->
								<!--										<div class="ml-2">-->
								<!--											<span class="font-bold block">{{-->
								<!--													"permission.featureCommandeIA" | translate-->
								<!--												}}</span>-->
								<!--										</div>-->
								<!--									</div>-->

								<!--									<p-inputSwitch-->
								<!--										[ngModel]="proprietesExploitation.featureCommandeIA === 'ENABLED'"-->
								<!--										(ngModelChange)="-->
								<!--											proprietesExploitation.featureCommandeIA = $event ? 'ENABLED' : 'DISABLED'-->
								<!--										"></p-inputSwitch>-->
								<!--								</li>-->
								<!--								<hr *ngIf="exploitation.hasOwnProperty('featureCommandeIA')" />-->
								<!--								<li-->
								<!--									class="flex align-items-center justify-content-between pt-2 pb-3"-->
								<!--									*ngIf="exploitation.hasOwnProperty('featureChatBot')">-->
								<!--									<div class="flex align-items-center justify-content-start">-->
								<!--										<div class="ml-2">-->
								<!--											<span class="font-bold block">{{-->
								<!--													"permission.featureChatBot" | translate-->
								<!--												}}</span>-->
								<!--										</div>-->
								<!--									</div>-->

								<!--									<p-inputSwitch-->
								<!--										[ngModel]="proprietesExploitation.featureChatBot === 'ENABLED'"-->
								<!--										(ngModelChange)="-->
								<!--											proprietesExploitation.featureChatBot = $event ? 'ENABLED' : 'DISABLED'-->
								<!--										"></p-inputSwitch>-->
								<!--								</li>-->
								<!--								<hr *ngIf="exploitation.hasOwnProperty('featureChatBot')" />-->
								<!--								<li-->
								<!--									class="flex align-items-center justify-content-between pt-2 pb-3"-->
								<!--									*ngIf="exploitation.hasOwnProperty('vae')">-->
								<!--									<div class="flex align-items-center justify-content-start">-->
								<!--										<div class="ml-2">-->
								<!--											<span class="font-bold block">{{ "permission.vae" | translate }}</span>-->
								<!--										</div>-->
								<!--									</div>-->

								<!--									<p-inputSwitch-->
								<!--										[ngModel]="proprietesExploitation.vae === 'VAE_ENABLED'"-->
								<!--										(ngModelChange)="-->
								<!--											proprietesExploitation.vae = $event ? 'VAE_ENABLED' : 'VAE_DISABLED'-->
								<!--										"></p-inputSwitch>-->
								<!--								</li>-->
							</ul>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="savePermission()"></button>
				</ng-template>
			</p-dialog>

			<p-dialog
				[(visible)]="addUserAccessToExploitationDialog"
				[style]="{ width: '450px' }"
				header="{{ 'user.addtocheptel' | translate }}"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<div class="field">
						<label for="name">{{ "input.userIdOrEmail" | translate }}</label>
						<p-autoComplete
							[(ngModel)]="newUserAccess.userId"
							[suggestions]="filteredEmails"
							(completeMethod)="filterEmails($event)"
							[dropdown]="true">
						</p-autoComplete>
						<small class="p-invalid red-text" *ngIf="errorUserId === 'emptyField'">{{
							"submit.champobligatoire" | translate
						}}</small>
					</div>
					<div class="field">
						<label class="mb-3">{{ "global.typeaccess" | translate }}</label>
						<div class="formgrid grid">
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category1"
									name="category"
									value="SAISIE"
									[(ngModel)]="newUserAccess.niveauAcces"></p-radioButton>
								<label for="category1">{{ "access.saisie" | translate }}</label>
							</div>
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category2"
									name="category"
									value="CONSULTATION"
									[(ngModel)]="newUserAccess.niveauAcces"></p-radioButton>
								<label for="category2">{{ "access.consultation" | translate }}</label>
							</div>
						</div>
						<small class="p-invalid red-text" *ngIf="errorAccess === 'emptyField'">{{
							"submit.champobligatoire" | translate
						}}</small>
					</div>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="addUserToCheptel()"></button>
				</ng-template>
			</p-dialog>

			<p-dialog
				[(visible)]="editUserAccessToExploitationDialog"
				[style]="{ width: '450px' }"
				header="{{ 'permission.edition' | translate }}"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<div class="field">
						<label class="mb-3">{{ "global.typeaccess" | translate }}</label>
						<div class="formgrid grid">
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category1"
									name="category"
									value="SAISIE"
									[(ngModel)]="currentNiveauAcces"></p-radioButton>
								<label for="category1">{{ "access.saisie" | translate }}</label>
							</div>
							<div class="field-radiobutton col-6">
								<p-radioButton
									id="category2"
									name="category"
									value="CONSULTATION"
									[(ngModel)]="currentNiveauAcces"></p-radioButton>
								<label for="category2">{{ "access.consultation" | translate }}</label>
							</div>
						</div>
					</div>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="saveNewUserAccess()"></button>
				</ng-template>
			</p-dialog>

			<p-dialog
				[(visible)]="editFtpDialog"
				[style]="{ width: '450px' }"
				header="{{ 'proprietes.ftp' | translate }}"
				[modal]="true"
				styleClass="p-fluid">
				<ng-template pTemplate="content">
					<form>
						<div class="field">
							<label for="ftp-identifiant">{{ "proprietes.utilisateur" | translate }}</label>
							<input
								type="text"
								pInputText
								id="ftp-identifiant"
								[(ngModel)]="proprietesExploitation.identifiantsEdeFtp.utilisateur"
								(ngModelChange)="resetFtpCheckStatus()"
								name="ftp-identifiant"
								required />
						</div>
						<div class="field">
							<label for="ftp-motdepasse">{{ "proprietes.motDePasse" | translate }}</label>
							<span class="p-input-icon-right" style="width: 100%">
								<input
									[type]="showPassword ? 'text' : 'password'"
									pInputText
									id="ftp-motdepasse"
									name="ftp-motdepasse"
									[(ngModel)]="proprietesExploitation.identifiantsEdeFtp.motDePasse"
									(ngModelChange)="resetFtpCheckStatus()"
									style="width: 100%"
									required />
								<i
									class="pi"
									[ngClass]="showPassword ? 'pi-eye-slash' : 'pi-eye'"
									(click)="togglePasswordVisibility()"
									style="cursor: pointer"></i>
							</span>
						</div>
						<div class="field flex align-items-center justify-content-start">
							<button
								pButton
								pRipple
								type="button"
								label="{{ 'proprietes.ftp.tester' | translate }}"
								icon="pi pi-link"
								class="p-button-text mr-2"
								style="width: auto"
								[disabled]="ftpCheckStatus === 'checking' || ftpCheckCooldown"
								(click)="checkFtpCredentials()"></button>
							<app-ea-spinner *ngIf="ftpCheckStatus === 'checking'"></app-ea-spinner>
							<span *ngIf="ftpCheckStatus === 'valid'" class="customer-badge status-active">{{
								"proprietes.ftp.valide" | translate
							}}</span>
							<span *ngIf="ftpCheckStatus === 'invalid'" class="customer-badge status-desactive">{{
								"proprietes.ftp.invalide" | translate
							}}</span>
						</div>
					</form>
				</ng-template>

				<ng-template pTemplate="footer">
					<button
						pButton
						pRipple
						label="{{ 'global.annuler' | translate }}"
						icon="pi pi-times"
						class="p-button-text"
						(click)="hideAllDialog()"></button>
					<button
						pButton
						pRipple
						label="{{ 'global.enregistrer' | translate }}"
						icon="pi pi-check"
						class="p-button-text"
						(click)="saveFtpCredentials()"></button>
				</ng-template>
			</p-dialog>

			<p-confirmDialog class="ui-confirmdialog-message" [style]="{ width: '450px' }"></p-confirmDialog>
		</div>
	</div>
</ng-container>
